// extracted by mini-css-extract-plugin
export default {"wrapper":"s7-z"};